import { InfographId, PageId, WidgetId } from 'types/idTypes';

type ChecksumHash = string;

type ChecksumCategory = 'infographs' | 'pages' | 'widgets';

type ChecksumMapType = {
  [key in ChecksumCategory]: { [Key: InfographId | PageId | WidgetId]: ChecksumHash };
};

/**
 * Singleton class to store the checksum map
 * This is used to check if the data has changed when saving
 * @class ChecksumManager
 */
class ChecksumManager {
  public static readonly DEFAULT_DATA = {
    infographs: {},
    pages: {},
    widgets: {},
  };

  private static instance: ChecksumManager;
  private checksumMap: ChecksumMapType | null;

  constructor() {
    this.checksumMap = ChecksumManager.DEFAULT_DATA;
  }

  public static getInstance(): ChecksumManager {
    if (!ChecksumManager.instance) {
      ChecksumManager.instance = new ChecksumManager();
    }
    return ChecksumManager.instance;
  }

  /**
   * Get the checksum map
   * @throws Error if the checksum map is not initialized
   * @returns ChecksumMapType
   */
  public get(): ChecksumMapType | null {
    if (this.checksumMap === null) return null;

    return this.checksumMap;
  }

  /**
   * Set the new checksum using category and id
   * @param checksumMap
   */
  public set(checksumMap: ChecksumMapType) {
    this.checksumMap = checksumMap;
  }

  /**
   * Patch the specific checksum hash
   * @param type
   * @param id
   * @param checksum
   */
  public patch(type: ChecksumCategory, id: InfographId | PageId | WidgetId, checksum: ChecksumHash) {
    if (!this.checksumMap) return;

    this.checksumMap[type][id] = checksum;
  }

  public delete(type: ChecksumCategory, id: InfographId | PageId | WidgetId) {
    if (!this.checksumMap) return;

    delete this.checksumMap[type][id];
  }
}

export default ChecksumManager;
